import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { TableColumn } from 'src/app/home/table/TableColumn';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { GlobalService } from 'src/app/service/global.service';
import { NotificationService } from 'src/app/service/notification.service';
import { ApprovalFlowService } from '../approval-flow-models/approval-flow.service';
import { WorkflowApproval } from '../approval-flow-models/workflow-approval.model';
import { WorkflowCriteria } from '../approval-flow-models/workflow-criteria.model';
import { WorkflowDefination } from '../approval-flow-models/workflow-defination.model';
import { WorkflowNames } from '../approval-flow-models/workflow-names.model';
import { WorkflowTicket } from '../approval-flow-models/workflow-ticket.model';

@Component({
  selector: 'app-adjustments-approval',
  templateUrl: './adjustments-approval.component.html',
  styleUrls: ['./adjustments-approval.component.css']
})
export class AdjustmentsApprovalComponent implements OnInit {
  workFlows: WorkflowNames[];
  workFlowLevel: WorkflowDefination[];
  workflowStages: WorkflowDefination[];
  workflowTicketsData: WorkflowTicket[] = [];
  ticketTrackingIds: WorkflowTicket[];
  ordersTableColumns: TableColumn[];
  ordersTableColumns2: TableColumn[];


  columnsData: any;
  ticketLevels: WorkflowTicket[];
  ordersTableColumns3: any;
  ticketStages: WorkflowTicket[];
  ticketSubStages: WorkflowTicket[];
  ordersTableColumns4: any;
  isAccessDisabled: boolean = false;

  constructor(private approvalFlowService: ApprovalFlowService, private authGurdService: AuthGaurdService,
    private notificationService: NotificationService, private httpService: HttpClient, private globalService: GlobalService) { }
  Headder: string = 'Ticket CreateView For Adjustments Approval'

  ngOnInit(): void {
    this.init();
    this.isAccessDisabled = this.globalService._permissionCheck('adjustments-approval');
    if (this.isAccessDisabled)
      this.notificationService.notify(NotificationType.WARNING, "Edit Permission Has Disabled Please Contact To Adminstrator");

  }

  private init() {
    this.initializeColumns();
    this.getTicketTrackingId()
    this.loadWorkflowNames();
  }

  loadWorkflowNames() {
    this.approvalFlowService.loadWorkflowNames()
      .subscribe((data: WorkflowNames[]) => {
        this.workFlows = data;

        console.log(this.authGurdService.favData);
        for (let workFlow of this.workFlows) {
          if (workFlow.workflow_name === 'Adjustments Approval') {//this.authGurdService.favData.nav_page_name) {
            console.log(workFlow.id);
            this.findLevlsByFlowId(workFlow.id);
          }
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  findLevlsByFlowId(id: number) {
    this.approvalFlowService.fetchWorkflowDef(id)
      .subscribe((data: WorkflowDefination[]) => {
        this.workFlowLevel = data;
        console.log(this.workFlowLevel);
        for (let workFlowLvl of this.workFlowLevel) {
          console.log(workFlowLvl);
          this.approvalFlowService.loadCriteria(workFlowLvl.flowId, workFlowLvl.level)
            .subscribe((data: WorkflowCriteria) => {
              console.log(data.criteria_sql);
              this.runSql(data.criteria_sql, workFlowLvl);
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            });
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public runSql(sql: string, workFlowLvl: WorkflowDefination) {
    console.log(workFlowLvl);
    this.approvalFlowService.runSql(sql)
      .subscribe((data: any) => {
        console.log(data);
        console.log(data.message);
        if (data.message === 'sucessTrue') {
          this.loadStages(workFlowLvl.flowId, workFlowLvl.level);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  loadStages(flowId: number, level: number) {
    this.approvalFlowService.loadStages(flowId, level)
      .subscribe((data: WorkflowDefination[]) => {
        this.workflowStages = data;
        console.log(this.workflowStages);
        for (let workFlowStage of this.workflowStages) {
          console.log(workFlowStage.level);
          this.approvalFlowService.loadStageCriteria(workFlowStage.flowId, workFlowStage.level, workFlowStage.stage)
            .subscribe((data: WorkflowCriteria) => {
              console.log(data);
              console.log(workFlowStage);
              this.runStageSql(data.criteria_sql, workFlowStage);
            }, (errorResponse: HttpErrorResponse) => {
              var msg: any;
              msg = errorResponse;
              this.notificationService.sendNotification(NotificationType.ERROR, msg);
            });
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  public runStageSql(sql: string, workFlowStage: WorkflowDefination) {
    console.log(sql);
    this.approvalFlowService.runSql(sql)
      .subscribe((data: any) => {
        console.log(data);
        if (data.message === 'sucessTrue') {
          console.log(workFlowStage);
          if (workFlowStage.approval_type === 'By Role') {
            console.log("inside if");
            console.log(workFlowStage.approval_value);
            this.findEmpIdsByRole(workFlowStage);
          }
          else if (workFlowStage.approval_type === 'By Cust Group') {
            console.log("inside else if");
            this.findCustGroupEmpIds(workFlowStage);
          }
          else {
            console.log("inside else");
            workFlowStage.id = 1;
            console.log(workFlowStage);
            this.saveWorkflowTicketDetails(workFlowStage);
          }
        } else {
          // this.notificationService.notify(NotificationType.ERROR, 'Failed');
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private findEmpIdsByRole(workFlowStage: WorkflowDefination) {
    console.log(workFlowStage);
    this.approvalFlowService.findEmpIdsByRole(workFlowStage.approval_value)
      .subscribe((data: AddUser[]) => {
        console.log(data);
        if (workFlowStage.approval_criteria === 'All Approval Required') {
          let i = 0;
          for (let user of data) {
            i = i + 1;
            workFlowStage.approval_value = user.employeeId;
            workFlowStage.id = i;
            this.saveWorkflowTicketDetails(workFlowStage);
          }
        }
        else {
          workFlowStage.approval_value = workFlowStage.approval_value;
          workFlowStage.id = 1;
          this.saveWorkflowTicketDetails(workFlowStage);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }



  private findCustGroupEmpIds(workFlowStage: WorkflowDefination) {
    console.log(workFlowStage);
    this.approvalFlowService.loadCustGroupEmpIds(workFlowStage.approval_value)
      .subscribe((data: WorkflowApproval[]) => {
        console.log(data);
        if (workFlowStage.approval_criteria === 'All Approval Required') {
          console.log("inside if");
          let i = 0;
          for (let workflowApproval of data) {
            console.log("inside for");
            i = i + 1;
            workFlowStage.id = i;
            workFlowStage.approval_value = workflowApproval.employee_id;
            this.saveWorkflowTicketDetails(workFlowStage);
          }
        }
        else {
          console.log("inside else");
          workFlowStage.id = 1;
          workFlowStage.approval_value = data[0].employee_id;
          this.saveWorkflowTicketDetails(workFlowStage);
        }
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  private saveWorkflowTicketDetails(workFlowStage: WorkflowDefination) {
    console.log(workFlowStage);
    const workflowTicket = new WorkflowTicket();
    workflowTicket.flow_id = workFlowStage.flowId;
    workflowTicket.stage = workFlowStage.stage;
    workflowTicket.level = workFlowStage.level;
    workflowTicket.sub_level = workFlowStage.id;
    workflowTicket.approval_from = workFlowStage.approval_value;
    workflowTicket.pending_from_dt = new Date();
    workflowTicket.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');
    workflowTicket.created_dt = new Date();
    //workflowTicket.status = 'pending';
    console.log(workflowTicket);
    this.workflowTicketsData.push(workflowTicket);
    if (this.workflowTicketsData.length)
      this.workflowTicketsData.sort((a, b) => (a.level > b.level) ? 1 : -1)

  }

  createTicket() {
    console.log(this.workflowTicketsData);
    this.workflowTicketsData[0].status = 'Pending';
    this.approvalFlowService.createWorkFlowTicket(this.workflowTicketsData)
      .subscribe(response => {
        response = response as ErrorResponseMessage;
        this.notificationService.notify(NotificationType.SUCCESS, `Ticket created successfully`);
        this.getTicketTrackingId();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });

  }

  getTicketTrackingId() {
    this.approvalFlowService.getTicketTrackingId()
      .subscribe((data: WorkflowTicket[]) => {
        this.ticketTrackingIds = data;
        console.log(this.ticketTrackingIds);
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }


  rowAction(row: any) {
    this.approvalFlowService.getTicetLevels(row.row.trackingId)
      .subscribe((data: WorkflowTicket[]) => {
        this.ticketLevels = data;
      });
  }

  innerRowAction(row: any) {
    this.approvalFlowService.getTicetStages(row.row.trackingId, row.row.level)
      .subscribe((data: WorkflowTicket[]) => {
        this.ticketStages = data;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  innerRowAction3(row: any) {
    this.approvalFlowService.getTicketSubLevels(row.row.trackingId, row.row.level, row.row.stage)
      .subscribe((data: WorkflowTicket[]) => {
        this.ticketSubStages = data;
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }
  exportExcel() {
    // this.fileName = 'kpidetails'
    // const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.kpiDetails);
    // const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    // const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    // this.saveExcelFile(excelBuffer, this.fileName);
  }

  initializeColumns(): void {
    this.httpService.get('../../../assets/json/tableColumns.json').subscribe(
      data => {
        this.columnsData = data;
        this.ordersTableColumns = this.columnsData.WorkFlowTicket;
        this.ordersTableColumns2 = this.columnsData.WorkFlowTicketLevel;
        this.ordersTableColumns3 = this.columnsData.WorkFlowTicketStage;
        this.ordersTableColumns4 = this.columnsData.WorkFlowTicketSubLevel;
        console.log(this.ordersTableColumns);
      }
    );
  }
}
